module.exports = __webpack_public_path__ + "static/media/robot_icon.a7717e85.svg";